import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Bot } from "lucide-react";
import api from "../lib/api";

const TL = { mattina: "Mattina", pomeriggio: "Pomeriggio", notte: "Notte" };
const fmtG = (iso) => { const s = new Date(iso + "T00:00:00").toLocaleDateString("it-IT", { weekday: "long", day: "2-digit", month: "2-digit" }); return s.charAt(0).toUpperCase() + s.slice(1); };

export function ConsegneOspiteAuto({ ospiteId }) {
  const { data = [], isLoading } = useQuery({ queryKey: ["consegne-ospite-auto", ospiteId], queryFn: async () => (await api.get(`/consegne/ospite/${ospiteId}/auto`)).data });
  const giorni = [...new Set(data.map((x) => x.data))];
  return (
    <div className="gr-card p-4 mb-3" data-testid="scheda-consegne-auto">
      <div className="flex items-center gap-2 mb-1"><Bot size={16} className="text-slate-600" /><b>Dalla consegna del turno</b><span className="text-xs text-muted-foreground">ultimi 3 giorni · scritto dal sistema</span></div>
      {isLoading && <p className="text-sm text-muted-foreground">Caricamento…</p>}
      {!isLoading && !data.length && <p className="text-sm text-muted-foreground py-2" data-testid="scheda-consegne-auto-vuoto">Nessuna novità registrata negli ultimi 3 giorni.</p>}
      {giorni.map((g) => (
        <section key={g} className="mt-3">
          <h4 className="font-bold border-b pb-1 mb-1">{fmtG(g)}</h4>
          {data.filter((x) => x.data === g).map((x, i) => (
            <div key={i} className="flex gap-3 py-1 text-[15px]" data-testid={`scheda-cons-auto-${g}-${i}`}>
              <b className="w-24 shrink-0">{TL[x.turno]}</b>
              <div className="flex-1">{x.imp && <b className="mr-1">★</b>}{x.testo}<div className="text-xs text-muted-foreground">{x.argomento}{x.ora ? ` · ${x.ora}` : ""}</div></div>
            </div>
          ))}
        </section>
      ))}
    </div>
  );
}
